import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Clock, CheckCircle2 } from 'lucide-react';

/** Fetches schedule status and returns it (polls every 60s). */
export function useScheduleStatus() {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    let mounted = true;
    const load = () => api.get('/schedule/status').then(r => mounted && setStatus(r.data)).catch(() => {});
    load();
    const iv = setInterval(load, 60000);
    return () => { mounted = false; clearInterval(iv); };
  }, []);
  return status;
}

export const OpenClosedBadge = ({ compact = false, testid = 'schedule-badge' }) => {
  const s = useScheduleStatus();
  if (!s) return null;
  if (s.is_open) {
    return (
      <span data-testid={testid}
            className={`inline-flex items-center gap-1 rounded-full ${compact ? 'px-2 py-0.5' : 'px-2.5 py-1'} bg-[#E8F5EE] text-[#1F6F4B] border border-[#B7DEC5] text-xs font-semibold`}>
        <CheckCircle2 size={12}/> Aperto ora
      </span>
    );
  }
  return (
    <span data-testid={testid}
          className={`inline-flex items-center gap-1 rounded-full ${compact ? 'px-2 py-0.5' : 'px-2.5 py-1'} bg-[#FFF6E1] text-[#8A5A00] border border-[#F4D89A] text-xs font-semibold`}>
      <Clock size={12}/> Chiuso – riapre {s.next_open_display}
    </span>
  );
};
